import {createTheme} from "@material-ui/core";
import {pink} from "@material-ui/core/colors";

export const theme = createTheme({
    palette: {
        primary: {
            main: '#4a148c',
        },
        secondary: pink,
    },
});